module.exports = __webpack_public_path__ + "ca8becf4f18db5bee12da16e94313a26.pdf";